import React, { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Linking, StyleSheet, Text, View } from 'react-native'
import { BtPlainText } from '@linqpal/components/src/ui'
import { colors } from '@linqpal/common-frontend/src/theme'
import LegalFiles from '../../../../../utils/helpers/legalFiles'

export const DownPaymentWireOptions: FC = () => {
  const { t } = useTranslation('global')

  return (
    <View style={styles.wrapper}>
      <BtPlainText style={styles.title}>
        {t('DownPaymentModal.wireHintTitle')}
      </BtPlainText>

      <BtPlainText style={styles.hint}>
        <Trans
          t={t}
          i18nKey="DownPaymentModal.wireHint"
          components={{
            downloadLink: (
              <Text
                style={styles.link}
                onPress={LegalFiles.downloadDownPaymentInstructions}
              />
            ),
            email: (
              <Text
                style={styles.link}
                onPress={() => Linking.openURL('mailto:support@bluetape.com')}
              />
            ),
          }}
        />
      </BtPlainText>
    </View>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    padding: 16,
    borderRadius: 8,
    backgroundColor: '#F4F9FD',
  },
  title: {
    lineHeight: 24,
    fontWeight: '700',
  },
  hint: {
    fontWeight: '500',
    lineHeight: 22,
  },
  link: {
    fontWeight: '700',
    color: colors.accent.secondary,
  },
})
